/**
 * Created by JackCui on 2021/12/2
 */
import batchHandleUrl from '../../../utils/url-handle'

export default batchHandleUrl({
  // 获取基本信息排列方式
  getTypography: {
    url: '/rule/execute/stringValue',
    type: 'get'
  }
})
